export default "__VITE_ASSET__16cf390d__"